import React, { Fragment, useContext, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import $ from "jquery";
import { postFileMethod, postMethod } from "../../requests";
import { UDContext } from "../../pages/admin/users/userDetails/UserDetails";
import UserPersonalData from "../user/UserPersonalData";
import { Checkbox } from "semantic-ui-react";

const EditPersonalUserData = (props) => {
    const { show, onClose, data } = props;
    const [formChanged, setFormChanged] = useState(false);
    const [blockForm, setBlockForm] = useState(false);
    const { checkServerData, showView, setAlerts } = useContext(BasicContext);
    const { reloadData } = useContext(UDContext);
    const { t } = useTranslation();
    const [user, setUser] = useState({
        name: data.user_name,
        surname: data.user_surname,
        phone: data.user_phone,
        ig: data.user_instagram ? data.user_instagram : "",
        address: data.user_address ? data.user_address : "",
        avatar_name: data.user_avatar_name ? data.user_avatar_name : null,
        terms: data.user_terms_agreement === "Y" ? true : false,
        rodo: data.user_rodo_agreement === "Y" ? true : false,
        ecc: data.user_ecc_agreement === "Y" ? true : false,
        newsletter: data.user_newsletter_agreement === "Y" ? true : false,
        user_long_booking: data.user_long_booking,
        user_roles: data.user_roles,
        user_status: data.user_stat_name,
    });
    const [avatar, setAvatar] = useState(null);

    const updateData = async (fileName) => {
        const res = await postMethod("/edit-user-personal-data", { user: user, userID: showView.params.userID, newAvatar: fileName });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t("success.editedUserData"), fading: 1500, id: "uploaded" }]);
            onClose();
            reloadData();
        } else setBlockForm(false);
    };
    const uploadAvatar = async () => {
        const data = new FormData();
        data.append("file", avatar);
        const res = await postFileMethod("/upload-avatar", data);
        if (checkServerData(res)) {
            updateData(res.data.fileName);
        } else setBlockForm(false);
    };

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (user.name.length === 0 || !user.name.replace(/\s+/, "")) {
            $("#addUserFormname").addClass("is-invalid");
            errors.push(t("error.emptyName"));
        }
        if (user.surname.length === 0 || !user.surname.replace(/\s+/, "")) {
            $("#addUserFormsurname").addClass("is-invalid");
            errors.push(t("error.emptySurname"));
        }

        if (user.phone.length === 0 || !user.phone.replace(/\s+/, "")) {
            $("#addUserFormphone").addClass("is-invalid");
            errors.push(t("error.emptyPhone"));
        } else if (!/^(\+48\s?)?(\d{3}\s?\d{3}\s?\d{3})$/.test(user.phone)) {
            $("#addUserFormphone").addClass("is-invalid");
            errors.push(t("error.invalidPhone"));
        }

        if (user.ig.length > 0 && !/^(?!.*\.\.)(?!.*\.$)(?!\d+$)[a-zA-Z0-9._]{1,30}$/.test(user.ig)) {
            $("#addUserFormig").addClass("is-invalid");
            errors.push(t("error.invalidIgNick"));
        }

        if (user.address.length > 0 && !user.address.replace(/\s+/, "")) {
            $("#addUserFormAddress").addClass("is-invalid");
            errors.push(t("error.invalidAddress"));
        }

        if (!user.terms) {
            errors.push(t("error.notCheckedRegulations"));
        }
        if (!user.rodo) {
            errors.push(t("error.notCheckedRodo"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t("info.editingUserData") }]);
            setBlockForm(true);
            if (avatar) uploadAvatar(data);
            else updateData(null);
        }
    };

    const agreements = [
        { value: user.terms, text: t("users.regulationAccept"), name: "terms" },
        { value: user.rodo, text: t("users.rodoAccept"), name: "rodo" },
        { value: user.ecc, text: t("users.mssgAccept"), name: "ecc" },
        { value: user.newsletter, text: t("users.newsletterAccept"), name: "newsletter" },
    ];

    return (
        <Modal show={show} onHide={onClose} backdrop={formChanged ? "static" : true}>
            <Form onSubmit={checkValidation} autoComplete="off">
                <Modal.Header closeButton>
                    <Modal.Title>{t("users.editPersonalUserData")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <UserPersonalData
                            formChanged={formChanged}
                            setFormChanged={setFormChanged}
                            user={user}
                            avatar={avatar}
                            setAvatar={setAvatar}
                            blockForm={blockForm}
                            setUser={setUser}
                            editView
                        />
                        <Col xs={12}>
                            {agreements.map((e, i) => (
                                <Fragment key={i}>
                                    <Checkbox
                                        label={<label className="form-label">{e.text}</label>}
                                        id={`addUserForm${e.name}`}
                                        checked={e.value}
                                        onChange={() => {
                                            setUser({ ...user, [e.name]: !e.value });
                                        }}
                                    />
                                </Fragment>
                            ))}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={onClose}>
                        {t("cancel")}
                    </Button>
                    <Button variant="primary" type="submit" disabled={!formChanged || blockForm}>
                        {t("saveChanges")}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default EditPersonalUserData;
